const initSplashUpsell = () => {
  
  const buyButtons = document.querySelectorAll('.variant-buy-button .button');
  const siteBody = document.querySelector('body');
  const addFallDetectionLink = document.querySelectorAll('.add-fall-detection');
  
  const splashUpsell = document.querySelector('section.shopify-section.careline-splash-upsell-section');
  const confirmUpsells = splashUpsell.querySelectorAll('.confirm-upsell');

  const positionOptions = '.splash-upsell-options-position';
  const paymentOptions = '.splash-upsell-options-payment';

  const dismissButtons = document.querySelectorAll('.careline-splash-upsell-section .go-to-cart');
  
  let originalButton;

  if(!splashUpsell || !buyButtons) {
    return false;
  }

  const showSplashPage = (ev) => {

    if(ev.target.classList.contains('splash-fd-link')) {
      hideNonFallDetectionUpsell();
      originalButton = ev.currentTarget.closest('.variant-outer').querySelector('.add-fall-detection');
      let original_variant = document.productJSON_splash.variants.find((variant) => {
        return `${variant.id}` === `${originalButton.dataset.value}` 
      });
      
    } else {
      originalButton = ev.currentTarget.closest('.variant-buy-button').querySelector('button.button');
      let original_variant = document.productJSON_splash.variants.find((variant) => {
        return `${variant.id}` === `${originalButton.dataset.variantid}` 
      });
      if (splashUpsell.querySelectorAll('.splash-upsell-box').length > 1) {
        splashUpsell.querySelector('.splash-upsell-container').classList.add('duo');
      }
      preselectPaymentOptions(original_variant);
    }
    
    siteBody.classList.add('splash-upsell-active');
    setTimeout(() => {
      splashUpsell.style.opacity = '1';
    }, 100);
  }

  const hideNonFallDetectionUpsell = () => {
    splashUpsell.querySelectorAll('.splash-upsell-box').forEach((upsell_box) => {
        if(!upsell_box.querySelector('.splash-upsell-options-position')) {
          upsell_box.style.display = 'none';
        }
      });
  }

  const dismissSplashPage = () => {
    originalButton.click();
  }

  const hideNonAnnualOptions = (original_variant) => {
    document.querySelectorAll(paymentOptions).forEach((payment_option) => {
      payment_option.querySelectorAll('input').forEach((paymentOption) => {
        if(paymentOption.dataset.title != original_variant.title) {
          paymentOption.closest('label').style.display = 'none';
        }
      });
    });
  }

  const preselectPaymentOptions = (original_variant) => {
    document.querySelectorAll(paymentOptions).forEach((payment_option) => {
      payment_option.querySelectorAll(`input[data-title='${original_variant.title}']`).forEach((paymentOption) => {
        paymentOption.setAttribute('checked', 'checked');
      });
    });

    if(document.splash_upsell_show_annual_only && original_variant.title.indexOf('Annual') >= 0) {
      hideNonAnnualOptions(original_variant);
    }
  }

  const togglePaymentOptions = (ev) => {
    ev.target.closest('.splash-upsell-box').querySelectorAll(paymentOptions).forEach((payment_option) => {
      payment_option.querySelectorAll('input[name^="payment-frequency"]').forEach(radioPayment => {
        if(radioPayment.dataset.parentId === ev.target.dataset.value) {
          radioPayment.closest('label').removeAttribute('hidden');
        } else {
          radioPayment.closest('label').setAttribute('hidden', true);
        }
      });
    });
  }

  const updatePaymentOptions = (ev) => {
    let payment_frequency = ev.target.dataset.title;
    ev.target.closest('.splash-upsell-box').querySelectorAll(paymentOptions).forEach((payment_option) => {
      payment_option.querySelectorAll(`input[data-title='${payment_frequency}']`).forEach((payment_option_input) => {
        if(ev.target.id != payment_option_input.id) {
          payment_option_input.closest('label').click();
        }
      });
    });
  }

  const addUpsellToCart = (ev) => {
    let cart_permalink = '/cart/';
    document.cartJSON_splash.forEach((item) => {
      if(item.accessory) {
        cart_permalink += `${item.id}:${item.quantity},`;
      }
    });

    let currentUpsellBox = ev.target.closest('.splash-upsell-box');
    let currentPositionOptions = currentUpsellBox.querySelector(positionOptions);
    let currentPaymentOptions = currentUpsellBox.querySelector(paymentOptions);
    let currentSetupFee = currentUpsellBox.dataset.setupFee;
    
    if (currentPositionOptions) {
      cart_permalink += `${currentPaymentOptions.querySelector(`input[data-parent-id='${currentPositionOptions.querySelector('input:checked').dataset.value}']:checked`).value}:1`;
    } else {
      cart_permalink += `${currentPaymentOptions.querySelector(`input:checked`).value}:1`;
    }

    if(currentSetupFee) {
      cart_permalink += `,${currentSetupFee}:1`;
    }
    
    document.location = `${cart_permalink}?attributes[Splash]=True`;
  }

  const replaceBuyButton = (buy_button) => {
    let newBuyButton = document.createElement('a');
        newBuyButton.classList.add('button','button--primary');
        newBuyButton.dataset.variantid = buy_button.dataset.variantid;
        newBuyButton.innerHTML = '<span>Add to Cart</span>';
    
    buy_button.closest('.variant-buy-button').append(newBuyButton);
    newBuyButton.addEventListener('click', showSplashPage);
  }

  const replaceFallDetectionLink = (fd_link) => {
    let newFDLink = document.createElement('div');
        newFDLink.classList.add('splash-fd-link');
        newFDLink.dataset.value = fd_link.dataset.value;
        newFDLink.dataset.setupFeeId = fd_link.dataset.setupFeeId;
    fd_link.after(newFDLink);
    newFDLink.addEventListener('click', showSplashPage);
  }

  buyButtons.forEach(buy_button => {
    replaceBuyButton(buy_button);
  });

  if(document.splash_upsell_on_fall_detection) {
    addFallDetectionLink.forEach(fd_link => {
      replaceFallDetectionLink(fd_link);
    });
  }

  dismissButtons.forEach(dismiss_button => {
    dismiss_button.addEventListener('click', dismissSplashPage);
  });

  if (document.querySelectorAll(positionOptions).length > 0) {
    document.querySelectorAll(positionOptions).forEach((position_option) => {
      position_option.querySelectorAll('input[name^="wearing-position"]').forEach(radioPosition => {
        radioPosition.addEventListener('change', togglePaymentOptions);
      });
    });
  }
  
  document.querySelectorAll(paymentOptions).forEach((payment_option) => {
    payment_option.querySelectorAll('input[name^="payment-frequency"]').forEach(radioPayment => {
      radioPayment.addEventListener('change', updatePaymentOptions);
    });
  });

  confirmUpsells.forEach(confirm_upsell => {
    confirm_upsell.addEventListener('click', addUpsellToCart);
  });
  
}

initSplashUpsell();